module.exports = __webpack_public_path__ + "static/3-0687bf833cc214aec98856cd8da54ec0.jpg";